/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { getEmployee } from '../Services/GranelServices';

const apiClientId = process.env.REACT_APP_API_CLIENT_ID;

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: process.env.REACT_APP_LOGIN_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: () => {},
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [`api://${apiClientId}/Api.ReadWrite`],
};

async function getGraphUser(userAccountId, accessToken) {
  const formData = new FormData();
  formData.append('Assertion', accessToken);
  formData.append('UserId', userAccountId);

  const response = await getEmployee(formData);
  return response;
}

export async function getAuthenticatedClient(userAccountId, accessToken) {
  let user = {};

  try {
    user = await getGraphUser(userAccountId, accessToken);
  } catch {
    // erro ignorado propositalmente
  }

  return user;
}
